export default {
  app: {
    featured: 'विशेष रुप से प्रदर्शित',
    random: 'अनियमित',
    explore: 'अन्वेषण करिय',
    keywords: 'सूचक-शब्द',
    search: 'खोजिये',
  },
  explore: {
    filters: 'छन्नी',
    resetFilters: 'छन्नी रीसेट करें',
    addKeyword: 'ूचक-शब्द जोड़ें',
  },
  recipe: {
    contributedBy: 'योगदानी',
    ingredients: 'सामग्री',
    directions: 'तैयारी',
    fullRecipe: 'पूरी विधि यहाँ देखें',
    similarDrinks: 'समान पेय',
  },
  featuredRecipes: {
    loadMore: 'और विधि देखिये',
  },
  recipeFind: {
    filterBy: 'छाने',
    name: 'नाम',
    ingredients: 'सामग्री',
    keywords: 'सूचक-शब्द',
    searchForIngredients: 'आप कई सामग्रियों को खोज सकते हैं उनके बीच खाली स्थान छोड़कर',
    searchForKeywords: 'आप कई सूचक-शब्द को खोज सकते हैं उनके बीच खाली स्थान छोड़कर',
  },
  recipeList: {
    viewRecipe: 'विधि देखे',
  },
  recipeToolbar: {
    print: 'प्रिंट करे',
    share: 'बाटें',
    shareOnFacebook: 'फेसबुक पर बाट',
    shareOnTwitter: '्विटर पर बाटे',
    copyURL: 'यूआरएल नकल करें',
    hideImage: 'चित्र छुपाएं',
  },
  favorites: {
    removeAllFavorites: 'सभी पसंदीदा हटाएं',
    noFavoriteDrinks: 'आपका कोई पसंदीदा पेय नहीं है',
    removeFavoritesPrompt: 'क्या आप वाकई सभी पसंदीदा हटाना चाहते हैं',
    delete: 'हटाइये',
    cancel: 'रद्द कर',
  },
  keywordList: {
    enterYourKeyword: 'अपना सूचक-शब्द दर्ज करें',
  },
  search: {
    findYourDrink: 'अपना पेय खोजें',
  },
  pageNotFound: {
    pageNotFound: 'आप जिस पृष्ठ की तलाश कर रहे हैं वह नहीं मिला।',
    backToHome: 'घर वापसी',
  },
};
